"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const utils_1 = require("../../lib/utils");
const provider_video_styles_1 = require("./provider-video.styles");
const sixteen_nine_iframe_1 = __importDefault(require("./sixteen-nine-iframe"));
const YouTubeVideoComponent = ({ url, accessibilityText, containerClass, iframeId, testId, allowFullScreen = true }) => {
    const [videoEmbedUrl, setVideoEmbedUrl] = (0, react_1.useState)(url);
    const [videoLoadingError, setVideoLoadingError] = (0, react_1.useState)(undefined);
    const isEmbedFormat = videoEmbedUrl.indexOf('embed') !== -1;
    (0, react_1.useEffect)(() => {
        if (!isEmbedFormat) {
            (0, utils_1.formatYouTubeVideoUrlToEmbed)(videoEmbedUrl)
                .then(setVideoEmbedUrl)
                .catch(setVideoLoadingError);
        }
    }, [videoEmbedUrl, isEmbedFormat]);
    if (videoLoadingError) {
        throw videoLoadingError;
    }
    return videoEmbedUrl && isEmbedFormat ? (react_1.default.createElement(sixteen_nine_iframe_1.default, { src: videoEmbedUrl, title: accessibilityText, id: iframeId, containerClass: containerClass, testId: testId, allowFullScreen: allowFullScreen })) : (react_1.default.createElement(provider_video_styles_1.Shimmer, null));
};
exports.default = YouTubeVideoComponent;
//# sourceMappingURL=youtube-video-component.js.map